/**
 * Canonical React Query keys for the AppsFlyer attribution surface.
 * Single source of truth for fetches + mutation invalidations. Tuples are
 * `as const` so React Query v5 narrows the QueryKey type.
 */
export const appsflyerKeys = {
  all: ['appsflyer'] as const,
  status: (brandId: string) => ['appsflyer', 'status', brandId] as const,
  apps: (brandId: string) => ['appsflyer', 'apps', brandId] as const,
  events: (brandId: string, appId: string) => ['appsflyer', 'events', brandId, appId] as const,
  templates: (brandId: string) => ['appsflyer', 'templates', brandId] as const,
  links: (campaignId: string) => ['appsflyer', 'links', campaignId] as const,
  report: (campaignId: string, range?: { from?: string; to?: string }) =>
    ['appsflyer', 'report', campaignId, range ?? {}] as const,
  series: (campaignId: string, range?: { from?: string; to?: string }) =>
    ['appsflyer', 'series', campaignId, range ?? {}] as const,
  health: (campaignId: string) => ['appsflyer', 'health', campaignId] as const,
  adminBrands: () => ['appsflyer', 'admin', 'brands'] as const,
} as const;
